<script>
export default {
    methods: {
        addHandler(event, func) {
            this.data.handlers.push({ event, func });
        },
        runHandler(event, ...params) {
            let returnVal;
            this.data.handlers
                .filter(x => x.event === event)
                .forEach(handler => {
                    returnVal = handler.func(this.data.interface, ...params);
                });
            return returnVal;
        },
    },
};
</script>
